// extracted by mini-css-extract-plugin
module.exports = {"gallery-card":"gallery-card_component_gallery-card__j6ubf","gallery-card__half":"gallery-card_component_gallery-card__half__rx2Fl"};